import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
  HostListener,
  OnInit,
  OnDestroy,
  Input,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { VoiceAssistantService } from 'src/app/shared/service/voiceAssistantService.service';


@Component({
  selector: 'app-interview-transcript',
  templateUrl: './interview-transcript.component.html',
  styleUrls: ['./interview-transcript.component.scss'],
  standalone :false
})
export class InterviewTranscriptComponent implements OnInit, OnDestroy {
  @Input() hide: boolean = false;
  @Input() isMaximized: boolean = false;
  @Input() hideInput: boolean = false;
  @Input() transcriptsArray: any[] = [];
  @Input() showDocumentLoader: boolean = false;
  @Input() loaderLogoSrc: string = '';

  private sub!: Subscription;

  @ViewChild('inputRef') inputRef!: ElementRef<HTMLInputElement>;
  textValue: string = '';
  fullViewFile: any | null = null;
  safePdfUrl!: SafeResourceUrl;

  constructor(private voiceAssistantService: VoiceAssistantService, private sanitizer: DomSanitizer) {}

ngOnInit() {
  this.sub = this.voiceAssistantService.messages$
  .pipe()
  .subscribe((messages) => {
    const processed = messages.slice().reverse().map(item => {
      const processed: any = { ...item };
      
      if (item?.attachment?.url) {
        processed.safeUploadedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(item.attachment.url);
      }
      
      if (item?.downloadPdf) {
        processed.safeDownloadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(item.downloadPdf);
      }
      
      return processed;
    });

    // console.log('Processed transcripts:', processed);
    this.transcriptsArray = processed;
  });
}


  ngOnDestroy() {
    this.sub?.unsubscribe();
  }


  sendMessage() {
    if (this.textValue.trim()) {
      const text = this.textValue.trim();
      // send to Vapi
      this.voiceAssistantService.sendMessageToVapi(text);
      // also push immediately so UI updates instantly
      const current = this.voiceAssistantService.messages$.getValue();
      this.voiceAssistantService.messages$.next([
        ...current,
        { role: 'user', text: text },
      ]);
      this.textValue = '';
      if (this.inputRef) {
        this.inputRef.nativeElement.value = '';
      }
    }
  }

openPdfInFullView(url: string) {
  this.fullViewFile = this.sanitizer.bypassSecurityTrustResourceUrl(url);
}


  async onDownloadUrl(url: string) {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = blobUrl;
    a.setAttribute('download', url.split('.com')[1] || 'file.pdf');
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
  }

  // @HostListener('document:keydown.escape', ['$event'])
  // onEscape() {
  //   if (this.fullViewFile) {
  //     this.fullViewFile = null;
  //   }
  // }

  trackByTranscriptId(index: number, item: any): string | number {
    return item?._id || index;
  }

  getSafePdfUrl(url: string): SafeResourceUrl {
  return this.sanitizer.bypassSecurityTrustResourceUrl(url);
}

closeFullView(event: Event) {
  event.stopPropagation();
  this.fullViewFile = null;
}


}
